import Swal from 'sweetalert2';
import APIserver from '../../../../api/axiosConfig';

export const handleSubmit = async (formData, handleClose, fetchProductos) => {
  try {
    //console.log('Datos enviados:', Array.from(formData.entries()));

    const response = await APIserver.post(`/api/productos`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });

    //console.log('Respuesta del servidor:', response);

    if (response.status === 200) {
      Swal.fire({
        title: 'Producto Creado',
        text: 'El producto ha sido creado exitosamente',
        icon: 'success',
        showConfirmButton: false,
        timer: 1500,
        timerProgressBar: true,
        iconColor: '#2fb380',
        confirmButtonColor: "#2c4cc4",
      }).then(() => {
        handleClose(); // Cerrar modal
        if (fetchProductos) {
          fetchProductos(); // Actualizar productos
        }
        window.location.reload(); // Recargar la página
      });
    } else {
      const errorData = await response.data;
      console.error('Detalles del error del servidor:', errorData);
      await Swal.fire({
        title: 'Error',
        text: `Error al crear el producto: ${errorData.message || 'Error desconocido'}`,
        icon: 'error',
        iconColor: '#da292e',
        confirmButtonColor: '#da292e',
      });
    }
  } catch (error) {
    console.error('Error al enviar el formulario:', error);

    if (error.response) {
      console.error('Respuesta del servidor:', error.response.data);
      await Swal.fire({
        title: 'Error',
        text: `Error del servidor: ${error.response.data.message || 'Error desconocido'}`,
        icon: 'error',
        iconColor: '#da292e',
        confirmButtonColor: '#da292e',
      });
    } else {
      await Swal.fire({
        title: 'Error',
        text: 'No se pudo conectar con el servidor.',
        icon: 'error',
        iconColor: '#da292e',
        confirmButtonColor: '#da292e',
      });
    }
  }
};


export const handleDelete = async (productId, fetchProductos) => {
  const result = await Swal.fire({
    title: '¿Estás seguro?',
    text: 'Esta acción no se puede deshacer',
    icon: 'warning',
    showCancelButton: true,
    iconColor: '#f4bd61',
    confirmButtonColor: '#2c4cc4',
    cancelButtonColor: '#da292e',
    confirmButtonText: 'Sí, eliminar',
    cancelButtonText: 'Cancelar'
  });

  if (result.isConfirmed) {
    try {
      await deleteProducto(productId); // Intentar eliminar el producto
      await Swal.fire({
        title: '¡Eliminado!',
        text: 'El producto ha sido eliminado correctamente',
        icon: 'success',
        iconColor: '#2fb380',
        confirmButtonColor: "#2c4cc4"
      });
      if (fetchProductos) {
        fetchProductos(); // Actualizar la lista de productos después de eliminar
      }
    } catch (error) {
      console.error('Error al eliminar el producto:', error);

      if (error.response && error.response.status === 400 && error.response.data.error) {
        // Mostrar mensajes específicos para productos asociados
        await Swal.fire({
          title: 'Error',
          text: error.response.data.error,
          icon: 'error',
          confirmButtonText: 'Aceptar',
          iconColor: '#da292e',
          confirmButtonColor: "#da292e"
        });
      } else {
        await Swal.fire({
          title: 'Error',
          text: 'Ocurrió un error al eliminar el producto',
          icon: 'error',
          confirmButtonText: 'Aceptar',
          iconColor: '#2fb380',
          confirmButtonColor: "#2c4cc4"
        });
      }
    }
  }
};
export const handleDeleteMultiple = async (productIds, onSuccess) => {
  const result = await Swal.fire({
    title: '¿Estás seguro?',
    text: `Se eliminarán ${productIds.length} productos. Esta acción no se puede deshacer.`,
    icon: 'warning',
    showCancelButton: true,
    iconColor: '#f4bd61',
    confirmButtonColor: '#2c4cc4',
    cancelButtonColor: '#da292e',
    confirmButtonText: 'Sí, eliminar',
    cancelButtonText: 'Cancelar'
  });

  if (result.isConfirmed) {
    try {
      const response = await APIserver.delete(`/api/productos`, { data: { ids: productIds } });
    
      const { deleted, notDeleted, associatedInTienda } = response.data;
    
      let message = `${deleted.length} productos han sido eliminados correctamente.`;
    
      if (notDeleted.length > 0) {
        const referencias = notDeleted.map(product => product.referencia).join(', ');
        message += `\nNo se pudieron eliminar los siguientes productos porque tienen asociaciones: ${referencias}.`;
      }
    
      // Mostrar mensaje de éxito
      await Swal.fire({
        title: 'Proceso finalizado',
        text: message,
        icon: 'info',
        iconColor: '#2fb380',
        confirmButtonColor: "#2c4cc4"
      });

      // Recargar la página después de 1 segundo
      setTimeout(() => {
        window.location.reload();
      }, 1000);
    } catch (error) {
      console.error('Error al eliminar los productos:', error);
    
      if (error.response && error.response.status === 400) {
        const { error: errorMessage, notDeleted } = error.response.data;
    
        let message = errorMessage;
        if (notDeleted && notDeleted.length > 0) {
          const referencias = notDeleted.map(product => product.referencia).join(', ');
          message += `\nProductos no eliminados.`;
        }
    
        await Swal.fire({
          title: 'Error',
          text: message,
          icon: 'error',
          iconColor: '#da292e',
          confirmButtonColor: '#da292e'
        });
      } else {
        await Swal.fire({
          title: 'Error',
          text: 'Ocurrió un error al eliminar los productos. Por favor, inténtalo nuevamente.',
          icon: 'error',
          iconColor: '#da292e',
          confirmButtonColor: '#da292e'
        });
      }
    }
  }
};



const deleteProducto = async (productId) => {
  try {
    await APIserver.delete(`/api/productos/${productId}`);
  } catch (error) {
    // Propagar el error para que sea manejado en handleDelete
    throw error;
  }
};


export const handleUpdate = async (productId, updatedData, handleClose, fetchProductos) => {
  try {
    // Verificamos los datos que se van a enviar
    //console.log('Datos a enviar para actualizar el producto:');
   // console.log(updatedData);  // Imprimimos el objeto actualizado

    // Enviamos los datos como JSON
    const response = await APIserver.put(`/api/productos/${productId}`, updatedData, {
      headers: {
        'Content-Type': 'application/json' // Aseguramos que se envíe como JSON
      }
    });
    if (response.status === 200) {
      Swal.fire({
        title: 'Producto Actualizado',
        text: 'El producto ha sido actualizado exitosamente',
        icon: 'success',
        showConfirmButton: false,
        timer: 1500,
        timerProgressBar: true,
        iconColor: '#2fb380',
        confirmButtonColor: "#2c4cc4"
      }).then(() => {
        handleClose(); // Cierra el modal después de que el alerta desaparezca
        if (fetchProductos) {
          fetchProductos(); // Llama a fetchProductos si está definida
        }
        // Recargar la página después de mostrar el alerta
        //window.location.reload();
      });
    } else {
      const errorData = await response.data;
      await Swal.fire({
        title: 'Error',
        text: 'Error al actualizar el producto',
        icon: 'error',
        iconColor: '#da292e',
        confirmButtonColor: "#da292e"
      });
    }
  } catch (error) {
    console.error('Error al enviar el formulario:', error);
    await Swal.fire({
      title: 'Error',
      text: 'Ocurrió un error al actualizar el producto',
      icon: 'error',
      iconColor: '#da292e',
      confirmButtonColor: "#da292e"
    });
  }
};